import { getItem, setItem } from './LocalStorage';

const getNumberOfRegisteredInstances = (localStorageKey) => {
  const nameList = getItem(localStorageKey) || [];
  return nameList.length;
};

const replaceValuesAfterEdition = (localStorageKey, valuesArray) => {
  setItem(localStorageKey, [...valuesArray]);
};

const onlyUnique = (value, index, self) => self.indexOf(value) === index;

const editTabStrip = (localStorageKey, originalIdentifier, newIdentifier, visibleCount) => {
  const nameList = getItem(localStorageKey) || [];
  const listWithoutOldIdentifier = [...nameList.filter((i) => i !== originalIdentifier)];
  const tempAddThisIdentifier = [...listWithoutOldIdentifier, newIdentifier];
  const uniqueNames = tempAddThisIdentifier.filter(onlyUnique);
  let editionError = null;
  if (uniqueNames.length === visibleCount) {
    replaceValuesAfterEdition(localStorageKey, uniqueNames);
  } else if (!newIdentifier) {
    editionError = 'There can be only one instance of tabstrip without identifier';
  } else {
    editionError = 'You are trying to edit a TabStrip instance with an identifier that is already in use';
  }
  return editionError;
};

const addTabStrip = (localStorageKey, newIdentifier, whatCountShouldBeAfterCreation) => {
  const nameList = getItem(localStorageKey) || [];
  const tempAddThisIdentifier = [...nameList, newIdentifier];
  const uniqueNames = tempAddThisIdentifier.filter(onlyUnique);
  let additionError = null;
  if (uniqueNames.length === whatCountShouldBeAfterCreation) {
    if (!newIdentifier) {
      additionError = 'Identifier is a required field and cannot be empty.';
    } else {
      replaceValuesAfterEdition(localStorageKey, uniqueNames);
    }
  } else if (!newIdentifier) {
    additionError = 'There can be only one instance of tabstrip without identifier';
  } else {
    additionError = 'You are trying to add a TabStrip instance with an identifier that is already in use';
  }
  return additionError;
};

export const isNameInUse = (localStorageKey, name) => {
  // Check the localStorage to see if some other TabStrip Instance is using my name
  const nameList = getItem(localStorageKey) || [];
  return nameList.indexOf(name) !== -1;
};

export const registerName = (localStorageKey, name) => {
  // Save my name in the localStorage
  const nameList = getItem(localStorageKey) || [];
  if (nameList.indexOf(name) === -1) setItem(localStorageKey, [...nameList, name]);
};

export const unregisterName = (localStorageKey, name) => {
  const nameList = getItem(localStorageKey) || [];
  return setItem(localStorageKey, [...nameList.filter((i) => i !== name)]);
};

export const areThereMultipleTabStrips = (className) => {
  const tabStrips = document.querySelectorAll(className) || [];
  return tabStrips.length > 1;
};

export const validateTabStrip = (scope, document, window, identifier, tabStrip) => {
  const localStorageKey = 'TS_NAMES';
  // eslint-disable-next-line max-len
  const attribute = '[behaviourobjecttype="SitefinityWebApp.Mvc.Controllers.PackageTabController"],[behaviourobjecttype="SitefinityWebApp.Mvc.Controllers.TabstripController"]';
  const validParentType = 'DIV';
  const allTabStripInstancesOnPage = document[0].querySelectorAll(attribute);
  const tabStripInstancesVisibleOnPage = [];
  allTabStripInstancesOnPage.forEach((i) => {
    if (i.parentNode.nodeName === validParentType) tabStripInstancesVisibleOnPage.push(i);
  });
  const registeredTabstripsCount = getNumberOfRegisteredInstances(localStorageKey);
  let error;

  if (tabStrip && tabStrip.Type === 'SelectB' && tabStrip.Tabs && tabStrip.Tabs.length > 1) {
    error = 'SelectB template only allows one tab. Please remove the additional one(s).';
    throw error;
  }

  if (tabStrip
    && (tabStrip.Type === 'SelectA' || tabStrip.Type === 'SelectD')
    && tabStrip.Tabs && tabStrip.Tabs.length > 6) {
    error = 'SelectD template only allows up to six tabs. Please remove the additional one(s).';
    throw error;
  }

  if (tabStripInstancesVisibleOnPage.length === registeredTabstripsCount) {
    // We are editing a tabStrip
    error = editTabStrip(
      localStorageKey,
      scope.originalIdentifier,
      identifier,
      tabStripInstancesVisibleOnPage.length,
    );
  } else if (!scope.originalIdentifier) {
    // We might be editing or adding a new tabStrip
    if (scope.originalTabsCount >= 1) {
      error = editTabStrip(
        localStorageKey,
        scope.originalIdentifier,
        identifier,
        tabStripInstancesVisibleOnPage.length,
      );
    } else {
      error = addTabStrip(localStorageKey, identifier, registeredTabstripsCount + 1);
    }
  } else {
    error = editTabStrip(localStorageKey,
      scope.originalIdentifier,
      identifier,
      tabStripInstancesVisibleOnPage.length);
  }

  if (error) throw error;

  window.addEventListener('beforeunload', () => unregisterName(localStorageKey, identifier));
};
